import React, { useState } from 'react';

export default function ControlModal({ type, value, onClose, onConfirm }) {
  const label = type === 'temp' ? 'อุณหภูมิ (°C)' : 'ความชื้น (RH%)';
  const color = type === 'temp' ? '#ff6666' : '#66ccff';
  const icon = type === 'temp' ? '🌡️' : '💧';

  const [controlValue, setControlValue] = useState(value);

  const handleIncrease = () => {
    setControlValue((prev) => Math.min(prev + 0.1, 100));
  };

  const handleDecrease = () => {
    setControlValue((prev) => Math.max(prev - 0.1, 0));
  };

  const handleConfirm = () => {
    onConfirm(parseFloat(controlValue.toFixed(1)));
    onClose();
  };

  // แปลงค่าความคืบหน้าสำหรับครึ่งวงกลม
  const radius = 70;
  const circumference = Math.PI * radius;
  const percent = Math.min(controlValue / 100, 1);
  const strokeDashoffset = circumference * (1 - percent);

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <h3 style={{ marginBottom: '1rem' }}>{icon} {label}</h3>

        <svg width="200" height="120" viewBox="0 0 200 120">
          <path
            d={`M 30 100 A 70 70 0 0 1 170 100`}
            fill="none"
            stroke="#eee"
            strokeWidth="20"
          />
          <path
            d={`M 30 100 A 70 70 0 0 1 170 100`}
            fill="none"
            stroke={color}
            strokeWidth="20"
            strokeDasharray={`${circumference}`}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
          />
        </svg>

        <div style={styles.valueRow}>
          <button onClick={handleDecrease} style={styles.controlBtn}>➖</button>
          <span style={styles.valueText}>
            {controlValue.toFixed(1)} {type === 'temp' ? '°C' : '%'}
          </span>
          <button onClick={handleIncrease} style={styles.controlBtn}>➕</button>
        </div>

        <div style={{ marginTop: '1.5rem' }}>
          <button style={styles.confirmBtn} onClick={handleConfirm}>✅ ยืนยัน</button>
          <button style={styles.closeBtn} onClick={onClose}>✖ ปิด</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999
  },
  container: {
    background: 'white',
    borderRadius: '12px',
    padding: '1.5rem',
    textAlign: 'center',
    minWidth: '300px',
    boxShadow: '0 0 12px rgba(0,0,0,0.2)'
  },
  valueRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '-20px',
    gap: '1rem'
  },
  valueText: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333'
  },
  controlBtn: {
    fontSize: '24px',
    background: '#f0f0f0',
    border: '2px solid #ccc',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0 3px rgba(0,0,0,0.1)'
  },
  confirmBtn: {
    background: '#28a745',
    color: 'white',
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: '8px',
    marginRight: '0.5rem',
    cursor: 'pointer'
  },
  closeBtn: {
    background: '#888',
    color: 'white',
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer'
  }
};
